
/* RC Tide — theme.js
   1) tile 微动视频：进入视口才加载，默认 0.8 倍速，悬停恢复 1.0
   2) ajax 加购（data-add-to-cart）+ 角标更新 + toast
   3) 产品页：缩略图切换、数量加减、Tabs
   4) 尊重 prefers-reduced-motion
*/
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- toast ---------- */
  function toast(msg) {
    var t = document.getElementById('toast');
    if (!t) return;
    t.textContent = msg;
    t.hidden = false;
    requestAnimationFrame(function () { t.classList.add('on'); });
    clearTimeout(t._tm);
    t._tm = setTimeout(function () {
      t.classList.remove('on');
      setTimeout(function () { t.hidden = true; }, 260);
    }, 2600);
  }
  window.RCtoast = toast;

  /* ---------- 1) tile 视频懒播 ---------- */
  function initTiles() {
    var vids = document.querySelectorAll('.tile .phv[data-src]');
    if (!vids.length) return;
    if (reduce || !('IntersectionObserver' in window)) return; // 降级：只显示静图
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting && !v.src) {
          v.src = v.getAttribute('data-src');
          v.load();
          v.playbackRate = 0.8;
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
          v.classList.add('playing');
        } else if (!en.isIntersecting && v.src) {
          v.pause();
        }
      });
    }, { rootMargin: '120px' });
    vids.forEach(function (v) { io.observe(v); });

    document.querySelectorAll('.tile').forEach(function (tile) {
      var v = tile.querySelector('.phv');
      if (!v) return;
      tile.addEventListener('mouseenter', function () { if (v.src) v.playbackRate = 1.0; });
      tile.addEventListener('mouseleave', function () { if (v.src) v.playbackRate = 0.8; });
    });
  }

  /* ---------- 2) ajax 加购 ---------- */
  function refreshCartCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = n; });
  }
  function addToCart(id, btn) {
    var old = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        refreshCartCount(cart.item_count);
        toast('Added to cart');
      })
      .catch(function () {
        toast('Could not add — try again');
      })
      .then(function () {
        if (btn) { btn.disabled = false; btn.textContent = old || 'Add to cart'; }
      });
  }
  function bindAddToCart() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-add-to-cart]');
      if (!btn) return;
      e.preventDefault();
      addToCart(btn.getAttribute('data-add-to-cart'), btn);
    });
  }

  /* ---------- 3) 产品页交互 ---------- */
  function initProduct() {
    var main = document.getElementById('mainImg');
    document.querySelectorAll('.thumbs > div').forEach(function (th) {
      th.addEventListener('click', function () {
        document.querySelectorAll('.thumbs > div').forEach(function (x) { x.classList.remove('on'); });
        th.classList.add('on');
        if (main) main.src = th.getAttribute('data-full');
      });
    });

    var qty = document.getElementById('qty');
    document.querySelectorAll('[data-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!qty) return;
        var v = parseInt(qty.value, 10) || 1;
        v += parseInt(b.getAttribute('data-qty'), 10);
        qty.value = Math.max(1, v);
      });
    });

    var sel = document.getElementById('variantSelect');
    var priceEl = document.getElementById('price');
    if (sel && priceEl) {
      try {
        var variants = JSON.parse(sel.getAttribute('data-variant-json') || '[]');
        sel.addEventListener('change', function () {
          var v = variants.filter(function (x) { return String(x.id) === sel.value; })[0];
          if (v) priceEl.textContent = (v.price / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
        });
      } catch (err) { /* 忽略 */ }
    }

    document.querySelectorAll('[data-tab]').forEach(function (b) {
      b.addEventListener('click', function () {
        document.querySelectorAll('[data-tab]').forEach(function (x) { x.classList.remove('on'); });
        document.querySelectorAll('.tabpane').forEach(function (x) { x.classList.remove('on'); });
        b.classList.add('on');
        var pane = document.getElementById(b.getAttribute('data-tab'));
        if (pane) pane.classList.add('on');
      });
    });
  }

  /* ---------- 4) 购物车数量步进（改完自动提交，无需手点 Update） ---------- */
  function initCart() {
    document.querySelectorAll('[data-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        var line = b.getAttribute('data-line');
        var inputs = document.querySelectorAll('input[name="updates[]"]');
        var target = inputs[parseInt(line, 10) - 1];
        if (!target) return;
        var v = (parseInt(target.value, 10) || 0) + parseInt(b.getAttribute('data-step'), 10);
        target.value = Math.max(0, v);
        var f = target.closest('form');
        if (f) f.submit();
      });
    });
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  ready(function () {
    initTiles();
    bindAddToCart();
    initProduct();
    initCart();
  });
})();
